import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-body" }
const _hoisted_2 = { class: "d-none container-fluid" }
const _hoisted_3 = { class: "row h-md-100 align-content-stretch" }
const _hoisted_4 = {
  class: "col-md-2",
  id: "dashboard-menu"
}
const _hoisted_5 = { class: "tab-content h-100 col-md-10" }
const _hoisted_6 = ["aria-hidden"]
const _hoisted_7 = {
  id: "team-pane",
  class: "h-100"
}
const _hoisted_8 = ["aria-hidden"]
const _hoisted_9 = {
  id: "billing-pane",
  class: "row"
}
const _hoisted_10 = ["aria-hidden"]
const _hoisted_11 = { id: "profile-pane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserWidget = _resolveComponent("UserWidget")!
  const _component_Header = _resolveComponent("Header")!
  const _component_DashboardMenu = _resolveComponent("DashboardMenu")!
  const _component_TeamPane = _resolveComponent("TeamPane")!
  const _component_BillingPane = _resolveComponent("BillingPane")!
  const _component_BillingAccountHistory = _resolveComponent("BillingAccountHistory")!
  const _component_ProfilePane = _resolveComponent("ProfilePane")!
  const _component_ErrorWidget = _resolveComponent("ErrorWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createVNode(_component_UserWidget, { ref: "userWidget" }, null, 512)
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DashboardMenu)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            id: "teams",
            class: _normalizeClass(_ctx.sectionPaneClass(_ctx.paneActive.teams, true)),
            "aria-labelledby": "teams-pill",
            role: "tabpanel",
            "aria-hidden": !_ctx.paneActive.teams
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_TeamPane, { ref: "teamPane" }, null, 512)
            ])
          ], 10, _hoisted_6),
          _createElementVNode("div", {
            id: "billing",
            class: _normalizeClass(_ctx.sectionPaneClass(_ctx.paneActive.billing, true)),
            "aria-labelledby": "billing-pill",
            role: "tabpanel",
            "aria-hidden": !_ctx.paneActive.billing
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_BillingPane, { ref: "billingPane" }, null, 512),
              _createVNode(_component_BillingAccountHistory, { ref: "billingAccountHistoryPane" }, null, 512)
            ])
          ], 10, _hoisted_8),
          _createElementVNode("div", {
            id: "settings",
            class: _normalizeClass(_ctx.sectionPaneClass(_ctx.paneActive.settings)),
            "aria-labelledby": "settings-pill",
            role: "tabpanel",
            "aria-hidden": !_ctx.paneActive.settings
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ProfilePane, { ref: "profilePane" }, null, 512)
            ])
          ], 10, _hoisted_10)
        ])
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "global-glasspane" }, [
      _createElementVNode("div", { class: "d-flex justify-content-center align-items-center fa-4x h-100" }, [
        _createElementVNode("div", null, [
          _createElementVNode("i", { class: "fa fa-spin fa-spinner" }),
          _createTextVNode(" Loading…")
        ])
      ])
    ], -1)),
    _createVNode(_component_ErrorWidget, { ref: "errorWidget" }, null, 512)
  ]))
}